/** 下单美元价：规整 JSON 浮点尾差 */
export function normalizeOrderPrice(price) {
  const n = Number(price);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.round(n * 100000) / 100000;
}

/** 下单数量：最多 6 位小数（USDC / 链上精度；截断，与后台一致） */
export function normalizeOrderQuantity(quantity) {
  const n = Number(quantity);
  if (!Number.isFinite(n) || n < 0.000001) return 0;
  // 极小值已截为零；整数直接返回，也覆盖大数的科学计数法。
  if (Number.isInteger(n)) return n;
  // 此范围的非整数用普通十进制表示，避免重复乘 1e6 时浮点尾差多截一位。
  const [integer, fraction] = String(n).split('.');
  return Number(`${integer}.${fraction.slice(0, 6)}`);
}

/** 买单所需平台 USDC（含轻微缓冲） */
export function estimateBuyOrderCostUsd(requestBody) {
  const price = Number(requestBody?.price ?? 0);
  const quantity = Number(requestBody?.quantity ?? 0);
  if (!Number.isFinite(price) || !Number.isFinite(quantity) || price <= 0 || quantity <= 0) {
    return 0;
  }
  return normalizeOrderPrice(price * quantity);
}
